export default function applyAppearance(theme) {
  // Token keys already include the `--` prefix (e.g. '--standard-normal-primary-color'),
  // so set them as-is. Prefixing again produced '----standard-normal-...' which never
  // matched the `var(--standard-normal-...)` references in SCSS.
  Object.entries(theme).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value)
  })
}
